// extracted by mini-css-extract-plugin
module.exports = {"collection":"Collection_collection__2d6tJ","header":"Collection_header__1r8K8","sceneItems":"Collection_sceneItems__1MQQ3","hasCategory":"Collection_hasCategory__16_lU"};